// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","368":"085931e1","455":"966c3b97","488":"b68881ba","977":"37d9e8f3"}[chunkId] + ".chunk.js";
};